import Blockly from "blockly";
import helpers from "blocks/helpers";

Blockly.Blocks.SetTempo = {
  message0: "set tempo to %1",
  args0: [
    {
      type: "input_value",
      name: "bpm",
      check: "Number",
    },
  ],
  previousStatement: "Statement",
  nextStatement: "Statement",
};

Blockly.Blocks.SetTempo.init = function () {
  this.jsonInit(Blockly.Blocks.SetTempo);
};

Blockly.JavaScript.SetTempo = function (block) {
  const x = helpers.codeForArg("bpm", block);

  if (typeof x === "undefined") {
    return "";
  } else {
    return `visualisation.setTempo(${x});`;
  }
};
